/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBalancesRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_balances.pb'
import {GetBalancesResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/get_balances.pb'


export const getBalances = (request: GetBalancesRequest, options?: CashRequestOptions) => post<GetBalancesRequest, GetBalancesResponse>("/cash-app/crow/get-balances", request, {...options, rejectOnError: true })